// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import '@src/styles/styles.scss';
import App from '@src/App';
import * as serviceWorker from '@src/serviceWorker';
import {Provider} from 'react-redux'
import {createStore} from 'redux'
import rootReducer from '@src/redux/reducers';

const store = createStore(rootReducer);

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
